<div
  class="report-kpi-tile d-flex align-items-center"
  role="button"
  tabindex="0"
  [attr.aria-label]="(labelKey() | translate) + ': ' + displayValue()"
  [class.severity-error]="severity() === 'error'"
  [class.severity-warning]="severity() === 'warning'"
  [class.severity-info]="severity() === 'info'"
  [class.severity-neutral]="severity() === 'neutral'"
  [class.is-warning]="warning()"
  (click)="onTileClick()"
  (keydown.enter)="onTileClick()"
  (keydown.space)="onTileClick(); $event.preventDefault()"
>
  <div class="tile-icon d-flex align-items-center justify-content-center flex-shrink-0">
    <mat-icon>{{ icon() }}</mat-icon>
  </div>
  <div class="tile-content d-flex flex-column min-w-0">
    <span class="tile-label">{{ labelKey() | translate }}</span>
    <div class="tile-value-row d-flex align-items-baseline">
      <span class="tile-value">{{ displayValue() }}</span>
      @if (percent() !== null) {
        <span class="tile-percent">{{ displayPercent() }}</span>
      }
    </div>
  </div>
</div>
